import {
  convertGraphQlToTicketEntities,
  convertGraphQlToTicketEntity,
  TicketEntity
} from "./TicketEntity";

export interface ChecklistEntity {
  id?: number;
  protectionGoalNiveau?: string;
  preparationDone?: boolean;
  type?: string;
  entries?: ChecklistEntryEntity[];
  propertyId?: number;
  looseTickets?: TicketEntity[];
}

export interface ChecklistEntryEntity {
  id?: number;
  name?: string;
  description?: string;
  preparationState?: ChecklistPreparationState;
  state?: ChecklistInspectionState;
  checklistEntryTemplateId?: string;
  plantId?: number;
  parentEntryId?: number;
  hasTickets?: boolean;
  hasEntries?: boolean;
  tickets?: TicketEntity[];
  entries?: ChecklistEntryEntity[];
}

export type ChecklistPreparationState =
  | "prove"
  | "irrelevant"
  | "inavailable"
  | "mixed";

export type ChecklistInspectionState =
  | ""
  | "clear"
  | "proven"
  | "maintenance"
  | "inspection"
  | "mixed";

export function convertGraphQlToChecklistEntity(c: any): ChecklistEntity {
  const flatEntries = convertGraphQlToChecklistEntryEntities(c.allEntries);
  const entries = flatEntries.length
    ? buildChecklistEntryTree(flatEntries)
    : convertGraphQlToChecklistEntryEntities(c.entries);

  return {
    id: c.id ?? 0,
    protectionGoalNiveau: c.protection_goal_niveau ?? "",
    preparationDone: c.preparation_done ?? false,
    type: c.type ?? "",
    entries,
    propertyId: parseInt(c.property?.id ?? 0, 10),
    looseTickets: convertGraphQlToTicketEntities(c.looseTickets)
  };
}

export function convertGraphQlToChecklistEntryEntities(
  data?: any[]
): ChecklistEntryEntity[] {
  if (!data) {
    return [];
  }

  return data.map<ChecklistEntryEntity>(e =>
    convertGraphQlToChecklistEntryEntity(e)
  );
}

export function convertGraphQlToChecklistEntryEntity(
  e: any
): ChecklistEntryEntity {
  if (!e) {
    return {};
  }

  return {
    id: e.id ?? 0,
    name: e.name ?? "",
    description: e.description ?? "",
    preparationState: e.preparation_state ?? "",
    state: e.state ?? "",
    checklistEntryTemplateId: e.checklist_entry_id ?? "",
    plantId: parseInt(e.plant?.id ?? 0, 10),
    parentEntryId: e.parent_entry_id ?? 0,
    hasTickets: e.has_tickets ?? false,
    hasEntries: e.has_entries ?? false,
    entries: convertGraphQlToChecklistEntryEntities(e.entries),
    tickets: convertGraphQlToTicketEntities(e.tickets)
  };
}

function buildChecklistEntryTree(
  flatEntries: ChecklistEntryEntity[]
): ChecklistEntryEntity[] {
  const entriesById = new Map<number, ChecklistEntryEntity>();
  const roots: ChecklistEntryEntity[] = [];

  flatEntries.forEach(entry => {
    const id = entry.id ?? 0;
    entry.entries = entry.entries ?? [];
    entriesById.set(id, entry);
  });

  flatEntries.forEach(entry => {
    const parentId = entry.parentEntryId ?? 0;
    if (parentId && entriesById.has(parentId)) {
      entriesById.get(parentId)?.entries?.push(entry);
    } else {
      roots.push(entry);
    }
  });

  return roots;
}
